import * as THREE from 'three';

export class AmbientEffects {
  private steam: THREE.Points;
  private dust: THREE.Points;
  private steamVel: Float32Array;
  private dustVel: Float32Array;

  constructor(parent: THREE.Group, grillPos: THREE.Vector3) {
    const steamCount = 48;
    const steamGeo = new THREE.BufferGeometry();
    const sp = new Float32Array(steamCount * 3);
    this.steamVel = new Float32Array(steamCount);
    for (let i = 0; i < steamCount; i++) {
      sp[i * 3] = grillPos.x + (Math.random() - 0.5) * 1.2;
      sp[i * 3 + 1] = grillPos.y + Math.random() * 0.5;
      sp[i * 3 + 2] = grillPos.z + (Math.random() - 0.5) * 0.8;
      this.steamVel[i] = 0.4 + Math.random() * 0.6;
    }
    steamGeo.setAttribute('position', new THREE.BufferAttribute(sp, 3));
    this.steam = new THREE.Points(
      steamGeo,
      new THREE.PointsMaterial({ color: 0xdddddd, size: 0.12, transparent: true, opacity: 0.35, depthWrite: false }),
    );
    parent.add(this.steam);

    const dustCount = 80;
    const dustGeo = new THREE.BufferGeometry();
    const dp = new Float32Array(dustCount * 3);
    this.dustVel = new Float32Array(dustCount);
    for (let i = 0; i < dustCount; i++) {
      dp[i * 3] = (Math.random() - 0.5) * 30;
      dp[i * 3 + 1] = 1.5 + Math.random() * 4;
      dp[i * 3 + 2] = (Math.random() - 0.5) * 24;
      this.dustVel[i] = 0.02 + Math.random() * 0.04;
    }
    dustGeo.setAttribute('position', new THREE.BufferAttribute(dp, 3));
    this.dust = new THREE.Points(
      dustGeo,
      new THREE.PointsMaterial({ color: 0xfff8e0, size: 0.04, transparent: true, opacity: 0.18, depthWrite: false }),
    );
    parent.add(this.dust);
  }

  tick(dt: number, t: number): void {
    const sp = this.steam.geometry.attributes.position as THREE.BufferAttribute;
    for (let i = 0; i < this.steamVel.length; i++) {
      let y = sp.getY(i) + this.steamVel[i] * dt;
      if (y > 3.5) {
        y = 1.2;
        sp.setX(i, -2 + (Math.random() - 0.5) * 1.2);
        sp.setZ(i, -10 + (Math.random() - 0.5) * 0.8);
      }
      sp.setY(i, y);
      sp.setX(i, sp.getX(i) + Math.sin(t + i) * dt * 0.15);
    }
    sp.needsUpdate = true;

    const dp = this.dust.geometry.attributes.position as THREE.BufferAttribute;
    for (let i = 0; i < this.dustVel.length; i++) {
      dp.setY(i, dp.getY(i) + Math.sin(t * 0.5 + i) * this.dustVel[i]);
    }
    dp.needsUpdate = true;
  }

  dispose(): void {
    this.steam.geometry.dispose();
    (this.steam.material as THREE.Material).dispose();
    this.dust.geometry.dispose();
    (this.dust.material as THREE.Material).dispose();
  }
}
